import { getElement, getElements } from '../utils/functional'
import { scrollToX, scrollToY } from '../utils/index'

export default class PageStory {
  constructor (el) {
    this.els = {
      startButton: getElement('[data-story-start]'),
      firstStoryLeft: getElement('[data-story-first]').offsetLeft,
      firstStoryTop: getElement('[data-story-first]').offsetTop,
      stories: getElements('[data-story]'),
      storiesTimelines: getElements('[data-story-timeline]'),
      toStoryButtons: getElements('[data-to-story]')
    }

    if (window.innerWidth < 900) {
      this.els.startButton.addEventListener('click', _ => {
        scrollToY(this.els.firstStoryTop, 10, 'easeInOutQuint')
      })

      this.els.toStoryButtons.forEach(button => {
        button.addEventListener('click', _ => {
          const id = button.dataset.toStory
          scrollToY(
            getElement(`[data-story="${id}"]`).offsetTop,
            10,
            'easeInOutQuint'
          )
        })
      })
    }

    if (window.innerWidth >= 900) {
      this.els.startButton.addEventListener('click', _ => {
        scrollToX(this.els.firstStoryLeft, 10, 'easeInOutQuint')
      })

      this.els.toStoryButtons.forEach(button => {
        button.addEventListener('click', _ => {
          const id = button.dataset.toStory
          scrollToX(
            getElement(`[data-story="${id}"]`).offsetLeft,
            10,
            'easeInOutQuint'
          )
        })
      })

      window.scrollTo(0, 0)
      window.addEventListener('mousewheel', this.horizontalScroll)
      window.addEventListener('scroll', _ => {
        const pageRightOffset = window.pageXOffset + window.outerWidth
        this.els.stories.forEach(story => {
          const storyId = story.dataset.story
          const storyOffsetLeft = story.offsetLeft
          const storyOffsetRight = storyOffsetLeft + story.offsetWidth
          const storyTimeline = getElement(`[data-story-timeline="${storyId}"]`)
          const storyWidth = storyOffsetRight - storyOffsetLeft
          let move = 0
          if (
            pageRightOffset >= storyOffsetLeft &&
            pageRightOffset <= storyOffsetRight
          ) {
            move = (storyOffsetRight - pageRightOffset) / (storyWidth / 100)
          } else if (pageRightOffset < storyOffsetLeft) {
            move = 100
          } else {
            move = 0
          }
          storyTimeline.style.right = `${move}%`
        })
      })
    }
  }

  horizontalScroll (event) {
    if (
      event.deltaY !== 0 &&
      document.body.classList.contains('drw-Drawer-active') === false
    ) {
      // manually scroll horizonally instead
      window.scroll(window.scrollX + event.deltaY * 5, window.scrollY)
      // prevent vertical scroll
      event.preventDefault()
    }
  }
}
